import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
// Firebase Storage no longer needed - using Cloudflare R2
import { getAuth } from 'firebase/auth'
import { getAnalytics } from 'firebase/analytics'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'

const firebaseConfig = {
  apiKey: "AIzaSyDZCjJN5EAMnLhgz72wjmXn4RnSa554ilE",
  authDomain: "megalith-maps.firebaseapp.com",
  projectId: "megalith-maps",
  // storageBucket: "megalith-maps.firebasestorage.app", // No longer needed - using Cloudflare R2
  messagingSenderId: "663809452389",
  appId: "1:663809452389:web:1afdc11e4e29b60c1b598c",
  measurementId: "G-RD46KXMYFB"
};



// Initialize Firebase
const app = initializeApp(firebaseConfig)
const db = getFirestore(app)
// const storage = getStorage(app) // No longer needed - using Cloudflare R2
const auth = getAuth(app)
const analytics = getAnalytics(app)
const functions = getFunctions(app, 'us-central1')

// Uncomment the following line to connect to the local functions emulator
// connectFunctionsEmulator(functions, "localhost", 5001);

/**
 * Get Algolia configuration securely from environment variables
 * @returns {Object} Algolia configuration with appId, searchKey, and indexName
 */
const getAlgoliaConfig = () => {
  // For client-side Vite applications, environment variables must be prefixed with VITE_
  return {
    appId: import.meta.env.VITE_ALGOLIA_APP_ID,
    searchKey: import.meta.env.VITE_ALGOLIA_SEARCH_API_KEY,
    indexName: import.meta.env.VITE_ALGOLIA_INDEX_NAME
  };
};

// Export without storage - fully replaced with Cloudflare R2
export { db, auth, analytics, functions, getAlgoliaConfig }
